import { eEstadoMaestro } from "../common/enumModel";
import { ITipoReglaModel } from "../interfaces/tipo-regla/ITipoReglaModel";

export class TipoReglaModel implements ITipoReglaModel {
    
    idTipoRegla : number;
    nombre : string;
    idEstado: eEstadoMaestro;
    estado: string;
    
    constructor(){
        this.idTipoRegla = 0;
        this.nombre = '';
        this.idEstado = eEstadoMaestro.ACTIVO;
        this.estado = '';
    }
}